export default {
    isLogged: false,
    user: null,
    mensajes: [] //m.leido, m.msj, m.remitente
}